var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-video web-video-xd"},[_c('div',{ref:"xdvideo",staticClass:"web-video-xd",attrs:{"data-options":_vm.optionsStr}}),(_vm.needHack)?_c('canvas',{staticStyle:{"display":"none"},attrs:{"width":"0","height":"0"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }